//Created by wangshuyi on 07/03/2018.

'use strict';

//配置信息
import plugin from "./common/common";
import API from "./common/apiConfig";

const contextPath = '/container-cargo'; // 启动时自动生成，无需手工配置
const apiPath = '/container-api'; // 启动时自动生成，无需手工配置
const erpPath = '/container-erp'; // 启动时自动生成，无需手工配置
const publicPath = '/container-public'; // 启动时自动生成，无需手工配置
const filePath = '/container-file'; // 启动时自动生成，无需手工配置
const fileTarget = 'http://2ways.gicp.net:9191/Boxnet.Web.H5.File'; // 启动时自动生成，无需手工配置
const plateCompanyId = 10000001; // 启动时自动生成，无需手工配置

const socketOpen = false;  // 启动时自动生成，无需手工配置
const socketPath = '/container-ws';  // 启动时自动生成，无需手工配置
//---------------------------------------------------

export default {
  install(Vue) {
    Vue.prototype.$common = plugin;
    Vue.prototype.$api = Vue.prototype.$Dolphin.formatApi(API);

    Vue.prototype.$Dolphin.path.contextPath = contextPath;
    Vue.prototype.$Dolphin.path.apiPath = apiPath;
    Vue.prototype.$Dolphin.path.erpPath = erpPath;
    Vue.prototype.$Dolphin.path.filePath = filePath;
    Vue.prototype.$Dolphin.path.fileTarget = fileTarget;
    Vue.prototype.$Dolphin.path.publicPath = publicPath;
    Vue.prototype.$Dolphin.path.plateCompanyId = plateCompanyId;

    Vue.prototype.$Dolphin.socket.open = socketOpen;
    Vue.prototype.$Dolphin.socket.connection = window.location.host;
    Vue.prototype.$Dolphin.socket.debug = false;
    Vue.prototype.$Dolphin.socket.options = { path: socketPath + '/socket.io/' };
  }
};
